import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/GlobalStyles.css";

import JobSeekerHomepage from "./pages/Home_page";
import LoginPage from "./pages/login";
import EmployeeRegistrationForm from "./pages/Employee-reg";
import InstitutionRegistrationForm from "./pages/institution-reg";
import ProfilePage from "./pages/ProfilePage";
import InstitutionHomePage from "./pages/InstitutionHomePage";
import ProfilePageInst from "./components/ProfilePageInst";
import TeacherJobsPage from "./pages/TeacherJobsPage";
import CandidateResults from "./pages/CandidateResults";
import AdminLogin from "./pages/admin/adminlogin";
import Dashboard from "./pages/admin/dashboard";
import PrivacyPolicy from "./pages/privacy-policy";
import TermsAndConditions from "./pages/terms-conditions";
import ContactUs from "./pages/ContactUs";
import PostJob from "./pages/post-job";
import AboutUS from "./pages/aboutus";
import Addcredits from "./pages/admin/addcredits";
import ManageUsers from "./pages/admin/ManageUsers";
import WalletPage from "./pages/WalletPage";
import AdminEditCandidate from "./pages/admin/admineditcandidate";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import JobDescription from "./pages/JobDescription";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import ViewJobDetails from "./pages/ViewJobDetails";
import CandidateDetails from "./pages/CandidateDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import WalkinForm from "./pages/Walkin";
import Planspage from "./pages/Planspage";

import ManageJobs from "./pages/manageJobs";
import ManageWalkins from "./pages/ManageWalkins";
import ViewInstitutionProfile from "./pages/ViewInstitutionProfile";
import SavedCandidates from "./pages/SavedCandidates";
import InvitedCandidates from "./pages/InvitedCandidates";
import JobApplicants from "./pages/JobApplicants";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem("token");
      const isInstitution = localStorage.getItem("institutionId");

      if (!token) {
        setLoading(false);
        return;
      }

      if (isInstitution) {
        setLoading(false);
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/profile/getCandprofile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setUser(res.data.candidate);

      } catch (err) {
        console.error("Failed to load user:", err);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          console.warn("Session expired. Logging out...");
          localStorage.clear();
          window.location.href = "/login";
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  if (loading) {
    return <div style={{ padding: "30px" }}>Loading...</div>;
  }
  //frontend routes
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover theme="colored" />
      <Routes>
        <Route path="/" element={<JobSeekerHomepage />} />
        <Route path="/jobs" element={<TeacherJobsPage />} />
        <Route path="/jobs/:location" element={<TeacherJobsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/user" element={<EmployeeRegistrationForm />} />
        <Route path="/inst" element={<InstitutionRegistrationForm />} />

        <Route
          path="/ProfilePage"
          element={
            <ProtectedRoute>
              <ProfilePage user={user} setUser={setUser} />
            </ProtectedRoute>
          }
        />

        <Route path="/InstitutionHomepage" element={<InstitutionHomePage />} />
        <Route
          path="/InstitutionProfile"
          element={
            <ProtectedRoute>
              <ProfilePageInst />
            </ProtectedRoute>
          }
        />


        <Route path="/candidate-results" element={<CandidateResults />} />
        <Route path="/candidate-details/:id" element={<CandidateDetails />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        {/* Protected Admin Routes with Layout */}
        <Route element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }>
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/addcredits" element={<Addcredits />} />
          <Route path="/admin/manage-users" element={<ManageUsers />} />
          <Route path="/admin/edit-candidate/:id" element={<AdminEditCandidate />} />
        </Route>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/post-job" element={<PostJob />} />
        <Route path="/about-us" element={<AboutUS />} />
        <Route path="/plans" element={<Planspage />} />

        <Route path="/institute/walkin-post" element={<WalkinForm />} />


        <Route path="/view-institution/:id" element={<ViewInstitutionProfile />} />
        <Route path="/manage-jobs" element={<ManageJobs />} />
        <Route path="/manage-walkins" element={<ManageWalkins />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/job-description/:id" element={<JobDescription />} />
        <Route path="/view-job/:id" element={<ViewJobDetails />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/saved-candidates" element={<SavedCandidates />} />
        <Route path="/invited-candidates" element={<InvitedCandidates />} />
        <Route path="/job-applicants/:jobId" element={<JobApplicants />} />



      </Routes>
    </Router>
  );
}

export default App;
